<template>
    <div v-if="months.length" class="flex align-items-center gap-3">
        <label class="text-color-secondary">{{ $t('lang.report.ads.period') }}</label>
        <AdaptersDropdown
            :modelValue="month"
            :options="options"
            optionValue="month"
            @change="onChange"
            class="ads_month_selector__input"
            panelClass="p-dropdown-panel-sm"
            append-to="body"
        >
            <template #value="{value}">
                <span>{{ label(value) }}</span>
            </template>
            <template #option="{option}">
                <span>{{ label(option.month) }}<template v-if="showCount && option.month"> · {{ count(option) }}</template></span>
            </template>
            <template #dropdownicon>
                <i class="pi pi-calendar" />
            </template>
        </AdaptersDropdown>
    </div>
</template>

<script>
import AdaptersDropdown from "../../component/adapters/Dropdown.vue";
import {Listeners} from "../../constants/listeners";

/**
 * «Период» в шапке страницы объявлений: текущее состояние (month = '') или месяц помесячного архива рекламы.
 * Состояние приходит из миксина Months (слот таблицы) через $emitter, выбор уходит туда же.
 * Без месяцев архива (не Яндекс, пустой архив) не показывается. show-count=false — без числа объявлений
 * у месяцев (страница запросов: там оно читалось бы как число запросов). Без текущего состояния
 * (withCurrentState из миксина) — только месяцы.
 */
export default {
    name: "AdsMonthSelector",
    props: {
        showCount: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            months: [],
            month: '',
            withCurrentState: true,
        }
    },
    created() {
        this.$emitter.on(Listeners.ADS_MONTHS_STATE, this.onState);
    },
    beforeUnmount() {
        this.$emitter.off(Listeners.ADS_MONTHS_STATE, this.onState);
    },
    computed: {
        options() {
            return this.withCurrentState ? [{month: ''}, ...this.months] : this.months;
        },
    },
    methods: {
        onState({months, month, withCurrentState}) {
            this.months = months;
            this.month = month;
            this.withCurrentState = withCurrentState;
        },
        onChange(e) {
            this.$emitter.emit(Listeners.ADS_MONTH_CHANGE, e.value);
        },
        label(month) {
            if (!month) {
                return this.$t('lang.report.ads.current_state');
            }
            const [year, mm] = month.split('-');
            const name = new Intl.DateTimeFormat(window.locale, {month: 'long'}).format(new Date(year, mm - 1, 1));

            return `${name[0].toUpperCase()}${name.slice(1)} ${year}`;
        },
        count(option) {
            return option.ads.toLocaleString(window.locale);
        },
    },
    components: {
        AdaptersDropdown,
    },
}
</script>

<style scoped>
.ads_month_selector__input:deep(.p-dropdown-label) {
    padding: 0.5rem 1rem;
}
.ads_month_selector__input:deep(.p-dropdown-trigger) {
    width: 2.75rem;
    background-color: #eee;
    border-left: 1px solid var(--surface-border);
    color: var(--text-color-secondary);
}
</style>
